import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CommunityFeedPage } from "@/features/community/components/community-feed-page";

// 📣 Explorar comunidad — feed cronológico de publicaciones (Wave 1 · agente C).
export const communityRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/community",
  component: CommunityFeedPage,
});
